import { useEffect } from "react";
import { postRequest } from "./request.js";

const MOUSE_EVENTS = ["mousemove"];
const KEYBOARD_EVENTS = ["keydown"];
const BREAK_LIMIT = 60000;

const useInteractionDetector = (pathName) => {
  let startTime = null, timeInteracted = 0, timeoutId = null;

  const getInteractedTime = (isWithinTimeout = false) => {
    timeInteracted = Date.now() - (startTime ? startTime : Date.now()) - (isWithinTimeout ? BREAK_LIMIT : 0);
    startTime = null;
    // console.log({ timeInteracted });
  }

  const updateInteractionTime = async () => {
    await postRequest(
      `${pathName}/track-interaction-time`,
      { time: timeInteracted }
    );
  }

  const handleInteraction = (e) => {
    if(timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }

    if(!startTime) {
      startTime = Date.now();
    }

    timeoutId = setTimeout(async () => {
      getInteractedTime(true);

      /*-----------Logic to push timeInteracted to backend goes here--------*/
      await updateInteractionTime();
    }, BREAK_LIMIT);
  }

  //#region 
  /*-----------------------------------*/
  //   let timeInteracted = 0, intervalId = null, timeoutId = null;
  //   const logConsole = () => console.log({ "interaction type": e.type, timeInteracted, timeoutId, intervalId });

  //   if(timeoutId) {
  //     clearTimeout(timeoutId);
  //     timeoutId = null;
  //   }
    
  //   timeoutId = setTimeout(() => {
  //     console.log("--------------------break detected---------------");
      
  //     clearInterval(intervalId);
  //     intervalId = null;
      
  //     timeInteracted -= BREAK_LIMIT;
      
  //     logConsole();
  //   }, BREAK_LIMIT * 1000);
    
  //   if(!intervalId) {
  //     intervalId = setInterval(() => {
  //       timeInteracted += 1;
  //     }, 1000);
  //   }
    
  //   logConsole();
  // }
  /*-----------------------------------*/
  
  /*-----------------------------------*/
  // let startTime = null, timeInteracted = 0;
  //   if(!startTime) {
    //     startTime = Date.now();
    //   } else {
      //     timeInteracted = Date.now() - startTime;
  //   }
  
  //   const timeoutId = setTimeout(() => {
  //     console.log("reset start timer");
  //     clearTimeout(timeoutId)
  //     startTime = null;
  //   }, 5000);

  //     console.log({ "interaction type": e.type, startTime, timeInteracted });
  // }
  /*-----------------------------------*/
  
  /*-----------------------------------*/
  // let previousTime = null, elapsedTime = null;
  
  // const handleInteraction = (e) => {
  //   const currentTime = new Date();
    
  //   if(previousTime) {
  //     // if((currentTime - previousTime) > 1000) previousTime = null;

  //     if(elapsedTime) {
  //       elapsedTime = currentTime - previousTime + elapsedTime;
  //     } else {
  //       elapsedTime = currentTime - previousTime;
  //     }
  //   }
    
  //   console.log({ "interaction type": e.type, lastTime: previousTime, currentTime, elapsedTime });
  //   previousTime = currentTime;
  // };
  /*-----------------------------------*/
  //#endregion

  const handleEditorClose = async (e) => {
    getInteractedTime();
    /*-----------Logic to push timeInteracted to backend goes here--------*/
    await updateInteractionTime();
  }

  useEffect(() => {
    const editorIframeInterval = setInterval(() => {
      if(window.editor) {
        // console.log("editor initialised, interaction detector running");
        clearInterval(editorIframeInterval);
        
        [...MOUSE_EVENTS, ...KEYBOARD_EVENTS].forEach((event) => window.addEventListener(event, handleInteraction));

        window.addEventListener("beforeunload", handleEditorClose);
      }
    }, 2000);

    return () => {
      window.removeEventListener("beforeunload", handleEditorClose);

      if(window.editor) {
        if(timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }

        getInteractedTime();
        (async () => {
          await updateInteractionTime();
        })();

        [...MOUSE_EVENTS, ...KEYBOARD_EVENTS].forEach((event) => window.removeEventListener(event, handleInteraction));

      }      
    }
  }, []);
};

export default useInteractionDetector;